<template>
  <LibraryListItem :class="{ 'pl-4': !showCheckbox }">
    <div
      v-if="showCheckbox"
      class="select-col document-checkbox"
      @click.stop
    >
      <DpplTooltip
        v-if="checkboxDisabled && checkboxDisabledReason"
        tooltip-placement="right"
      >
        <template #activator="{ onMouseenter, onMouseleave }">
          <div
            class="select-col-activator"
            @mouseenter="onMouseenter"
            @mouseleave="onMouseleave"
          >
            <DpplSimpleCheckbox
              :model-value="selected"
              :option="{ id: ulid, label: `Select ${title || 'profile'}` }"
              hide-label
              size="md"
              border-radius="6px"
              class="checkbox"
              :disabled="checkboxDisabled"
              @update:model-value="$emit('update:selected', $event)"
            />
          </div>
        </template>
        <template #tooltip-content>
          <p class="text-body-2 text-textDark">
            {{ checkboxDisabledReason }}
          </p>
        </template>
      </DpplTooltip>
      <DpplSimpleCheckbox
        v-else
        :model-value="selected"
        :option="{ id: ulid, label: `Select ${title || 'profile'}` }"
        hide-label
        size="md"
        border-radius="6px"
        class="checkbox"
        :disabled="checkboxDisabled"
        @update:model-value="$emit('update:selected', $event)"
      />
    </div>

    <div class="document-title-row">
      <div class="document-title text-textDarkest">
        {{ title }}
      </div>
      <ArchivedBadge v-if="isArchived" />
    </div>

    <BasicCellWithTooltip :text="jobCode" />
    <BasicCellWithTooltip :text="jobLevel" />
    <BasicCellWithTooltip :text="department" />
    <BasicCellWithTooltip :text="lastRevisedAt" />
  </LibraryListItem>
</template>

<script setup>
import { computed } from 'vue';
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import BasicCellWithTooltip from '@/components/jobProfiles/profileListItemCells/BasicCellWithTooltip.vue';
import ArchivedBadge from '@/components/jobProfiles/profileListItemCells/ArchivedBadge.vue';
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

const props = defineProps({
  ulid: { type: String, default: '' },
  title: { type: String, default: '' },
  jobCode: { type: String, default: '' },
  jobLevel: { type: String, default: '' },
  department: { type: String, default: '' },
  lastRevised: { type: String, default: '' },
  selected: { type: Boolean, default: false },
  showCheckbox: { type: Boolean, default: false },
  isArchived: { type: Boolean, default: false },
  checkboxDisabled: { type: Boolean, default: false },
  checkboxDisabledReason: { type: String, default: '' },
});

defineEmits(['update:selected']);

const lastRevisedAt = computed(
  () => (props.lastRevised ? new Date(props.lastRevised).toLocaleDateString('en-US') : ''),
);
</script>

<style lang="less" scoped>
.document-list-item {
  grid-template-columns: repeat(2, 1fr);
}

.document-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

.document-title {
  min-width: 0;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-checkbox {
  justify-self: center;
}

.select-col-activator {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
